import React from 'react'
import {Poddar } from '../../assets/index'
import '../../styles/AboutPage.css'
import '../../styles/AboutPageTwo.css'

const AboutPageTwo = () => {
  return (
   <div className='overflow:hidden'>
      <div className="aboutUs-vision-mission-div" id="vmd">

<h2 className='about-us-h2-headings' id="m">Vision and mission</h2>

<div className='aboutUs-mission-internal' id="vm">
   
<div className="bg-orange-500 text-white p-8 rounded-lg max-w-2xl mx-auto text-justify font-inter " id="b">
      <div className='relative top-[3rem]'>
      <p className="text-xl font-semibold mb-4 font-playfair">
        2 Years On Job Practical
      </p>
      <span className="block text-3xl font-bold mb-4 tracking-wider uppercase font-montserrat">
        University Recognized MBA
      </span>
      <p className="text-lg font-medium font-playfair leading-relaxed">
        Learn through Practical Exposure & Live Business Internship
      </p>
      </div>
    </div>
    <div className='aboutUs-near-university text-justify' id='abu'>
        <p> Imagine working on real-life projects, analyzing financial data, and developing strategies
            to drive business growth. You'll have the opportunity to work with Experienced finance
            professionals, gaining invaluable insights and practical skills that will prepare you for a
            successful career in the finance industry</p>

        <p> <b> Practical MBA :</b>   Unlock Your Business Potential with <span style={{ fontWeight: '700', color: '#ff6600' }}> 1 Year of Job Experience
            & 15 Certifications </span></p>

        <p className='aboutUs-next-level'> Are you ready to take your finance skills to the next level?</p>
        <p>The Practical MBA program offers a comprehensive approach to business education,
            blending rigorous coursework with practical experiences. Participants have the
            opportunity to gain one year of valuable job experience, giving them a competitive edge
            in the job market. Additionally, the program provides certifications covering various crucial
            business areas. Alongside this, participants receive focused training in soft skills and other
            valuable sessions. Through hands-on learning & a customizable curriculum, participants
            develop critical thinking & problem-solving abilities. The program also fosters networking
            opportunities, preparing individuals to thrive in the ever-evolving business landscape. Join
            the Practical MBA to unlock your business potential, acquire real-world experience, earn
            certifications, and enhance your soft skills</p>
    </div>
</div>
</div>


<div className="aboutUs-reason-div" id="ard">
                <h2 className='about-us-h2-headings'>Reasons Behind Choosing FINXL BUSINESS SCHOOL</h2>
                <ul>
                    <li className='custom-bullet'>
                        <h5 className='aboutUs-h5-headings'>  Analysing student potentials & working on their STRENGTHS & WEAKNESS</h5>
                        <p> Every student has unique skills, and they may not be aware of them due to a lack of industry exposure and the required on-the-job training and guidance.
                            At FBS, we have designed our programs in such a way that candidate interests and strengths are identified in the first year itself while engaging them in various practical,
                            real-time live business cases and interactions with real clients of Factsheet Inc. and other partners. Also, our team will strive across the program to identify student weaknesses
                            and then work on fundamentals to overcome them</p>
                    </li>
                    <li className='custom-bullet'>
                        <h5 className='aboutUs-h5-headings'>   Performance Measurement </h5>
                        <p> At regular intervals, we measure each student's performance metrics to check their growth trajectory and overall growth. It will be published every month based on client
                            feedback and on-the-ground performance. Our trainers and industry experts will counsel every student on a regular basis and guide them about the best industry practices
                            and skills required. Industry professionals will brief them about various job profiles and their future growth prospects</p>
                    </li>
                    <li className='custom-bullet'>
                        <h5 className='aboutUs-h5-headings'> Practical On Job Learning </h5>
                        <p> FBS offers professional management learning through live sessions, workshops, projects, and internships. Students work as paid interns or employees in their second year,
                            gaining one year of experience and becoming ready for their dream job</p>
                    </li>
                    <li className='custom-bullet'>
                        <h5 className='aboutUs-h5-headings'> Personal Trainer Available For Every Group (10 STUDENTS) </h5>
                        <p> At FBS, we allot a personalized trainer or mentor for every group of 10 students to ensure all students progress equally and learn after  classroom sessions. A mentor will be
                            available 24 hours a day to assist and re-train students in case of doubt</p>
                    </li>
                    <li className='custom-bullet'>
                        <h5 className='aboutUs-h5-headings'> Placement Assistance</h5>
                        <p>Our placement team & mentors consistently work on every student to make them job ready from Day 1, Our expert will work on</p>
                        <br />
                        <ul>

                            <li><i className='bx bx-check'></i>Aptitude test preparation</li>
                            <li><i className='bx bx-check'></i>Communication & presentation skills</li>
                            <li><i className='bx bx-check'></i>Profile building & narrative for final placement</li>
                            <li><i className='bx bx-check'></i>Resume building, Linkedin profile branding, job portals updation</li>
                            <li><i className='bx bx-check'></i>Mock interviews with industry experts</li>
                            <li><i className='bx bx-check'></i>Case studies preparation for written test of various top companies</li>

                        </ul>
                        <br />
                        <p> From deciding their best-suited niche to facilitating on-field required skills to having them placed in top-notch global  companies where they deserve to be. On average, our
                            students have landed a package of Rs. 7 LPA, ranging from Rs. 3.50 LPA to Rs. 17.62 LPA CTC. Our students are performers from day one at jobs, and employers don’t need to
                            provide any hand-holding training apart from their process or tool related training</p>
                    </li>
                </ul>

            </div>

            <div className='aboutUs-vision-div'>


                <div className='aboutUs-vision-img-div' id="img">
                    <img src={Poddar} alt="" />
                </div>
                <div id='ov'>
                    <ul>

                        <li>
                            <h5 className='aboutUs-h5-vision-headings'>Our Vision</h5>
                            <p>Revolutionizing education since 2017. We've transformed the learning of 10,000+ students. Our customized teaching patterns and pedagogies support individual growth and success. Recognizing uniqueness, we unveil strengths and carve greatness. Corporate finance knowledge is efficiently served.</p>
                        </li>

                        <li>
                            <h5 className='aboutUs-h5-vision-headings'>Our Aim </h5>
                            <p>
                                <ul>
                                    <li className='custom-bullet'>Providing a lifelong skill-set</li>
                                    <li className='custom-bullet'> Experiences with some software that are used by MNCs</li>
                                    <li className='custom-bullet'>Upscale the presentation skills and  Confidence</li>
                                    <li className='custom-bullet'> Guaranteed Internship & Placement</li>
                                    <li className='custom-bullet'> Supplying effective corporate exposure</li>
                                    <li className='custom-bullet'> Value inculcation & social cohesio</li>
                                </ul>
                            </p>
                        </li>

                        <li className='custom-bullet-sep'>
                            <h5 className='aboutUs-h5-vision-headings'> Our Mission</h5>
                            <p>We aspire to attain an education system that makes sense for the long term in our students' lives. The breakdown of this goal helps us
                                stay aligned with this bigger mission</p>

                            <ul>
                                <li><i className='bx bx-check'></i>Help students understand different Domains via practical involvement, to recognize their best fit</li>
                                <li><i className='bx bx-check'></i>Encourage students to achieve excellence in those fields</li>
                                <li><i className='bx bx-check'></i>Creating a balanced environment of learning and practicing</li>
                                <li><i className='bx bx-check'></i>Providing them with the right exposure to the corporate world and expertise right after the first year</li>
                                <li><i className='bx bx-check'></i>Emphasis on real market knowledge</li>
                                <li><i className='bx bx-check'></i>On-the-job experience during our training</li>
                                <li><i className='bx bx-check'></i>Embracing every idea, passion, and Interest</li>
                                <li><i className='bx bx-check'></i>Developing financially responsible Citizens for our society</li>
                            </ul>

                        </li>
                    </ul>
                </div>


            </div>
            <div style={{ padding: '2rem' }}>
                <p> Since the inception of FBS, we have been inspired by the motivational great saint and businessman, "Bhai Ji Hanuman Prasad Poddar". We believe in his integrated spirituality and
                    his belief in business practices. His life and work provide a number of insights for students as well. Following his wonderful philosophies, FBS has evolved into the finest institution
                    where the whole objective is to make our students Confident and Intelligent and develop them holistically to face any challenge in the world</p>
            </div>

          
          
   </div>
  
  )
}

export default AboutPageTwo